import { render } from "./aside.vue?vue&type=template&id=0fa4a316&ts=true"
import script from "./aside.vue?vue&type=script&lang=ts"
export * from "./aside.vue?vue&type=script&lang=ts"

import "./aside.vue?vue&type=style&index=0&id=0fa4a316&lang=scss"

import exportComponent from "/Users/cuixg/Desktop/web/magic/admin/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__